import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { ROUTE_PATHS } from 'router/routes'

const ImportantRulesFAQPage = React.lazy(() => import('pages/ImportantRulesFAQPage/ImportantRulesFAQPage'))

export class ImportantRulesPageModule {
  getRoutes() {
    return (
      <Route key={ROUTE_PATHS.IMPORTANT_RULES} path={ROUTE_PATHS.IMPORTANT_RULES}>
        <Switch>
          <Route
            key={ROUTE_PATHS.IMPORTANT_RULES}
            path={ROUTE_PATHS.IMPORTANT_RULES}
            component={ImportantRulesFAQPage}
          />
        </Switch>
      </Route>
    )
  }
}
